import * as React from 'react';

function F1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.327 4.348V3.78H5v15.335h1.327v-5.76c3.978 1.173 7.956-3.01 11.933-.567V3.78c-3.978-2.443-7.955 1.74-11.933.568zm10.695 4.464a5.586 5.586 0 00-2.07-.2V6.46c-.72.058-1.44.224-2.159.426v2.158c.713-.2 1.426-.364 2.138-.423v2.151c-.72.058-1.439.224-2.158.426V9.039c-.72.203-1.439.441-2.159.646v2.158c-.719.204-1.439.374-2.158.439v-2.155c.715-.065 1.43-.234 2.145-.437V7.53c-.72.205-1.439.375-2.158.44v2.154c-.706.062-1.41.022-2.116-.186V7.78c.71.21 1.42.249 2.129.185V5.903c.72-.065 1.439-.235 2.159-.44v2.063c.719-.204 1.438-.443 2.158-.645V4.82c.72-.202 1.439-.368 2.158-.426v2.062c.697-.056 1.394-.012 2.091.198v2.159z"
        fill="currentColor"
      />
    </svg>
  );
}

export default F1;
